'use client';
import React from 'react';
import PropTypes from 'prop-types';
import NoSidebar from '../../layouts/NoSidebar';
import Button from '../../components/Button';
import Link from 'next/link';
import s from './HomePage.module.scss';
import { t } from '../../i18n';
import Image from '../../components/Image';
import Icon from '../../components/Icon';
import AnimatedLogo from '../../components/AnimatedLogo/AnimatedLogo';
import Richtext from '../../components/Richtext/Richtext';

import Marquee from 'react-fast-marquee';
import HeroScroll from '../../components/HeroScroll/HeroScroll';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import HomeImageText from '../../components/HomeImageText/HomeImageText';
import CareerCard from '../../components/CareerCard/CareerCard';
import HomeFooter from '../../components/HomeFooter/HomeFooter';

const HomePage = ({
    hero = {},
    service = {},
    imageText = {},
    career = {},
    loginUrl = '',
    image = {},
    siteSetting = {},
    showLoginButton,
}) => {
    return (
        <div className={s.Root}>
            <div className={s.HeaderWrapper}>
                <div className={s.Header}>
                    <Icon name="LogoWhite" className={s.Logo} />
                    {loginUrl && showLoginButton && (
                        <Button
                            modifier="Primary"
                            size="Large"
                            icon="Arrow"
                            url={loginUrl}
                            title={t('general.clientLogin')}
                            className={s.LoginButton}
                        />
                    )}
                </div>
            </div>
            <div className={s.Container}>
                <div className={s.Content}>
                    <HeroScroll {...hero} />
                    <ServiceCard {...service} />
                    <HomeImageText {...imageText} />
                    <CareerCard {...career} />
                </div>
                <HomeFooter {...siteSetting} />
            </div>
        </div>
    );
};

HomePage.propTypes = {
    headline: PropTypes.string.isRequired,
    preamble: PropTypes.string.isRequired,
    loginUrl: PropTypes.string.isRequired,
};

export default NoSidebar(HomePage);
